module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "view"
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-532c3176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/View.vue
// module id = 634
// module chunks = 0